<script lang="ts" setup>
import { TextQuaternary } from '@shared/ui/typography'

import { useFooter } from './footer.hook'

defineOptions({
  name: 'FooterCopyright',
})

const { currentYear } = useFooter()

</script>

<template>
  <TextQuaternary class="footer-copyright">
    © Brighterly {{ currentYear }}
  </TextQuaternary>
</template>

<style scoped lang="scss" src="./FooterCopyright.scss" />